import { BaseRouteService } from 'core/services';

class RateServiceRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'rate-service/';
	}

	getRates = () => {
		return this.uriTemplateService.parse(`${this.base}get-rates`).expand();
	};

	getReturnRates = () => {
		return this.uriTemplateService.parse(`${this.base}get-return-rates`).expand();
	};

	getRateCalculatorRates = () => {
		return this.uriTemplateService.parse(`${this.base}get-rate-calculator-rates`).expand();
	};

	getRateCalculatorBulkRates = () => {
		return this.uriTemplateService.parse(`${this.base}get-rate-calculator-bulk-rates`).expand();
	};
}

export default RateServiceRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/RateServiceRouteService.js